// extracted by mini-css-extract-plugin
export default {"contentWrapper":"Home_contentWrapper__Kx-o2","appear":"Home_appear__9eftT","dashboardWrapper":"Home_dashboardWrapper__FR5S+"};